import { jsxs, jsx } from 'react/jsx-runtime';
import { getCssBackground } from '../theme/cssBackground.js';
import React__default, { forwardRef, useRef } from 'react';
import { styled } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { IconImage } from '@fabric-app/icons/old';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';

const ImageElement = styled.img.withConfig({
  displayName: "Image__ImageElement",
  componentId: "sc-4005f2d1-0"
})([
  `max-width:100%;object-fit:contain;border-radius:6px;`,
  ` `,
  ` `,
  ``
], (p) => p.fullWidth ? "width: 100%;" : "", (p) => p.fullHeight ? "height: 100%;" : "", getCssBackground("secondary"));
const ImageFailure = styled.div.withConfig({
  displayName: "Image__ImageFailure",
  componentId: "sc-4005f2d1-1"
})([
  `display:flex;flex-direction:column;min-height:0;gap:8px;align-items:center;justify-content:center;width:100%;height:100%;`,
  ` `,
  ` min-width:85px;flex-grow:1;background:`,
  `;color:`,
  `;border-radius:6px;pointer-events:none;padding:1rem;font-size:80%;text-align:center;`
], ({ width }) => width ? `width: ${width};` : "", ({ height }) => height ? `height: ${height};` : "", cssVar["color-bg-secondary"], cssVar["color-text-tertiary"]);
const Image = /* @__PURE__ */ forwardRef(({ src, alt, className, errorText = "Failed to load image", onError, children, ...props }, ref) => {
  const [failed, setFailed] = React__default.useState(false);
  const failureRef = useRef(null);
  const [rect] = useDomContentRect(failureRef);
  const showFallback = Boolean(failed || !src);
  return showFallback ? children ?? /* @__PURE__ */ jsxs(ImageFailure, {
    "data-img-failure": true,
    ...props,
    ref: failureRef,
    style: {
      ...props.style,
      fontSize: rect?.width ? rect.width < 115 ? "10px" : void 0 : void 0
    },
    children: [
      /* @__PURE__ */ jsx(IconImage, {
        width: 32,
        height: 32
      }),
      errorText
    ]
  }) : /* @__PURE__ */ jsx(ImageElement, {
    ...props,
    ref,
    src,
    alt,
    className,
    onError: (event) => {
      setFailed(true);
      onError?.(event);
    }
  });
});
Image.displayName = "Image";

export { Image, ImageElement };
//# sourceMappingURL=Image.js.map
